const remMultiplier = 0.625;
export const spacing = {
    spacing0: '0',
    spacing2: `calc(0.2rem * ${remMultiplier})`,
    spacing4: `calc(0.4rem * ${remMultiplier})`,
    spacing8: `calc(0.8rem * ${remMultiplier})`,
    spacing12: `calc(1.2rem * ${remMultiplier})`,
    spacing16: `calc(1.6rem * ${remMultiplier})`,
    spacing20: `calc(2rem * ${remMultiplier})`,
    spacing24: `calc(2.4rem * ${remMultiplier})`,
    spacing28: `calc(2.8rem * ${remMultiplier})`,
    spacing32: `calc(3.2rem * ${remMultiplier})`,
    spacing40: `calc(4rem * ${remMultiplier})`,
    spacing48: `calc(4.8rem * ${remMultiplier})`,
    spacing64: `calc(6.4rem * ${remMultiplier})`,
    spacing70: `calc(7rem * ${remMultiplier})`,
    spacing80: `calc(8rem * ${remMultiplier})`,
    spacing96: `calc(9.6rem * ${remMultiplier})`,
    spacing128: `calc(12.8rem * ${remMultiplier})`,
};
export default spacing;
